import { SHIFT_NOT_READY_FOR_PAYMENT_FLAG } from '@/store/modules/shifts/constants'

const PAYABLE_PAYMENT_STATUSES = ['not_paid', 'cancelled']
const REQUEST_PAYMENT_RESUME_STEPS = Object.freeze({
  CREATED: 1,
  PROCESSING: 1,
  CONFIRMED: 2
})

export const getRequestPaymentResumeStep = status => REQUEST_PAYMENT_RESUME_STEPS[String(status || '').toUpperCase()]

export const isRequestPaymentShiftEligible = shift => {
  const paymentInfo = shift?.external_payment_info || {}

  return (
    shift?.status === 'completed' &&
    paymentInfo.ready_for_pay_status === 'ready' &&
    PAYABLE_PAYMENT_STATUSES.includes(paymentInfo.payment_status)
  )
}

export const getRequestPaymentShiftReason = shift => {
  if (shift?.status !== 'completed') return 'Only completed shifts can be requested.'

  const paymentInfo = shift?.external_payment_info || {}
  if (paymentInfo.ready_for_pay_status !== 'ready') {
    return paymentInfo.not_ready_to_pay_flags?.length
      ? paymentInfo.not_ready_to_pay_flags
          .map(item => SHIFT_NOT_READY_FOR_PAYMENT_FLAG[item]?.title ?? 'Unknown')
          .join(', ')
      : 'This shift is not ready for payment.'
  }
  if (!PAYABLE_PAYMENT_STATUSES.includes(paymentInfo.payment_status)) {
    return 'This shift is already included in a payment.'
  }

  return ''
}

export const getRequestPaymentShiftTotals = shift => {
  const paymentInfo = shift?.external_payment_info || {}
  const calculations = Array.isArray(paymentInfo.calculations) ? paymentInfo.calculations : []

  return {
    hours: calculations.reduce(
      (sum, calculation) => sum + (calculation.only_total ? 0 : Number(calculation.hours) || 0),
      0
    ),
    amount:
      calculations.reduce((sum, calculation) => sum + (Number(calculation.total) || 0), 0) +
      (Number(paymentInfo.extra) || 0)
  }
}

export const getRequestPaymentSummary = shifts => {
  const associates = new Set()

  return shifts.reduce(
    (summary, shift) => {
      const associateId = shift?.external_payment_info?.associate?.id
      if (associateId) associates.add(associateId)

      const totals = getRequestPaymentShiftTotals(shift)
      summary.shifts += 1
      summary.hours += totals.hours
      summary.amount += totals.amount
      summary.associates = associates.size

      return summary
    },
    { associates: 0, shifts: 0, hours: 0, amount: 0 }
  )
}

export const formatRequestPaymentMoney = amount =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((Number(amount) || 0) / 100)
